import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

const PaymentCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");

  useEffect(() => {
    verifyPayment();
  }, []);

  const verifyPayment = async () => {
    try {
      // الحصول على payment_id من URL
      const paymentId = searchParams.get("payment_id");
      const orderId = searchParams.get("order_id");

      if (!paymentId) {
        setError("معرف الدفع غير موجود");
        setStatus("error");
        return;
      }

      // التحقق من حالة الدفع
      const response = await axios.get(
        `https://blomengdalis-tester.com/backend/verify-payment.php?payment_id=${paymentId}`,
      );

      if (response.data.success) {
        // الدفع نجح
        setStatus("success");
        setTimeout(() => {
          navigate(
            `/payment-success?order_id=${orderId || response.data.order_id}`,
          );
        }, 1000);
      } else {
        // الدفع فشل
        setStatus("failed");
        setTimeout(() => {
          navigate(
            `/payment-error?order_id=${orderId || response.data.order_id}&error=${response.data.error || "فشل الدفع"}`,
          );
        }, 1000);
      }
    } catch (err) {
      console.error("Verification error:", err);
      setError(err.response?.data?.error || "حدث خطأ أثناء التحقق من الدفع");
      setStatus("error");

      setTimeout(() => {
        navigate(
          "/payment-error?error=" + (err.response?.data?.error || "حدث خطأ"),
        );
      }, 2000);
    }
  };

  return (
    <div
      dir="rtl"
      className="min-h-screen bg-gray-50 flex items-center justify-center p-4"
    >
      <div className="max-w-md w-full bg-white p-8 text-center">
        {status === "loading" && (
          <>
            <div className="mb-6">
              <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900"></div>
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              جاري التحقق من عملية الدفع...
            </h1>
            <p className="text-gray-600">
              الرجاء الانتظار بينما نتحقق من حالة الدفع
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="mb-6">
              <svg
                className="w-16 h-16 text-green-500 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              تم التحقق بنجاح
            </h1>
            <p className="text-gray-600">جاري التوجيه...</p>
          </>
        )}

        {status === "failed" && (
          <>
            <div className="mb-6">
              <svg
                className="w-16 h-16 text-red-500 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              فشلت عملية الدفع
            </h1>
            <p className="text-gray-600">جاري التوجيه...</p>
          </>
        )}

        {status === "error" && (
          <>
            <div className="mb-6">
              <svg
                className="w-16 h-16 text-red-500 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">حدث خطأ</h1>
            <p className="text-red-600 mb-4">{error}</p>
            <button
              onClick={() => navigate("/checkout")}
              className="bg-black text-white px-6 py-2 hover:bg-gray-800"
            >
              العودة للدفع
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentCallback;
